const CUSTOMER_STATUSES = {
  INVITE_SENT: "invite sent",
  NO_ACCESS: "no access",
  ACTIVE: "active",
  SUSPENDED: "suspended"
}

const customerStatusColorMap = {
  [CUSTOMER_STATUSES.INVITE_SENT]: "gold",
  [CUSTOMER_STATUSES.ACTIVE]: "green",
  [CUSTOMER_STATUSES.SUSPENDED]: "red",
  [CUSTOMER_STATUSES.NO_ACCESS]: "default"
}

const customerEditableStatuses = [
  CUSTOMER_STATUSES.INVITE_SENT,
  CUSTOMER_STATUSES.NO_ACCESS
]

/**
 * The same soft accent tokens already used for Project Logs' action icons
 * and the Customer avatar's palette — reused here rather than antd's
 * saturated preset `Tag` colors, which read as too strong for a status that
 * should stay glanceable, not alarming.
 */
const SOFT_TAG_COLORS = {
  gray: { color: "#6B7280", background: "#F3F4F6" },
  green: { color: "#16A34A", background: "#ECF9EF" },
  blue: { color: "#0284C7", background: "#E6F6FE" },
  red: { color: "#DC2626", background: "#FEF2F2" }
} as const

type SoftTagColor = keyof typeof SOFT_TAG_COLORS

interface StatusTagInfo {
  label: string
  tone: SoftTagColor
  /** Only "active" gets the small icon-in-tag treatment; the rest are plain text. */
  icon?: "send" | "dot"
}

/**
 * One tag per customer, read directly off the single real `Customer.Status`
 * value — no "No Access" label anywhere, and no derived splitting into two
 * tags (an earlier pass tried that; this reads more clearly as one glance).
 * `active` also drives the small presence dot on the avatar in
 * `CustomerCell.tsx`. No new backend value is introduced, and there is no
 * "expired"/"failed" state to show since `Customer.Status` has none.
 */
const customerInvitationStatusInfo: Record<string, StatusTagInfo> = {
  [CUSTOMER_STATUSES.NO_ACCESS]: { label: "Not Invited", tone: "gray" },
  [CUSTOMER_STATUSES.INVITE_SENT]: {
    label: "Invitation Sent",
    tone: "blue",
    icon: "send"
  },
  [CUSTOMER_STATUSES.ACTIVE]: { label: "Active", tone: "green", icon: "dot" },
  [CUSTOMER_STATUSES.SUSPENDED]: { label: "Suspended", tone: "red" }
}

export {
  CUSTOMER_STATUSES,
  SOFT_TAG_COLORS,
  type SoftTagColor,
  customerInvitationStatusInfo,
  customerStatusColorMap,
  customerEditableStatuses
}
